import React, { ReactNode } from 'react';
import { ButtonGroup as StandardButtonGroup } from '@emorg-prd/standard-react';

interface ButtonGroupProps {
	responsive?: boolean;
	children?: ReactNode;
	optionalClass?: string;

}

export const ButtonGroup: React.FC<ButtonGroupProps> = (props) => (
	<StandardButtonGroup {...(props.responsive && { type: 'em-c-btn-group--responsive' })} children={props.children} optionalClass={props.optionalClass}/>
);
